const base = ['tripDocuments'] as const
export const forTrip = (id: string) => [...base, id] as const
export const forURL = (documentKey: string) => [...base, documentKey] as const
